import { identity } from 'lodash-es'
import { viewportIsSmall } from '#app/lib/screen'
import { i18n } from '#user/lib/i18n'

const gutenbergText = () => i18n('on_website', { name: 'Gutenberg.org' })

export const platforms = {
  'wdt:P724': {
    icon: 'archive-org',
    text () { return i18n('on_website', { name: 'Internet Archive' }) },
    url (id: string) { return `https://archive.org/details/${id}` },
  },
  'wdt:P1938': {
    icon: 'gutenberg',
    text: gutenbergText,
    url (id: string) { return `${gutenbergBase()}ebooks/author/${id}` },
  },
  'wdt:P2002': {
    icon: 'twitter',
    text (username: string) { return `@${username}` },
    url (username: string) { return `https://twitter.com/${username}` },
  },
  'wdt:P2003': {
    icon: 'instagram',
    text: identity,
    url (username: string) { return `https://instagram.com/${username}` },
  },
  'wdt:P2013': {
    icon: 'facebook',
    text: identity,
    url (facebookId: string) { return `https://facebook.com/${facebookId}` },
  },
  'wdt:P2034': {
    icon: 'gutenberg',
    text: gutenbergText,
    url (id: string) { return `${gutenbergBase()}ebooks/${id}` },
  },
  'wdt:P2397': {
    icon: 'youtube',
    text () { return '' },
    url (channelId: string) { return `https://www.youtube.com/channel/${channelId}` },
  },
  'wdt:P4033': {
    icon: 'mastodon',
    text: identity,
    url (address: string) {
      const [ username, domain ] = address.split('@')
      return `https://${domain}/@${username}`
    },
  },
  'wdt:P4258': {
    icon: 'gallica',
    text () { return i18n('on_website', { name: 'Gallica' }) },
    url (id: string) { return `https://gallica.bnf.fr/ark:/12148/${id}` },
  },
  'wdt:P7085': {
    icon: 'tiktok',
    text (username: string) { return `@${username}` },
    url (username: string) { return `https://www.tiktok.com/@${username}` },
  },
} as const

function gutenbergBase () {
  const base = viewportIsSmall() ? 'http://m.' : 'https://www.'
  return `${base}gutenberg.org/`
}
